const options = {
  5: "bg-indigo-50/5",
  10: "bg-indigo-50/10",
  25: "bg-indigo-50/25",
  50: "bg-indigo-50/50",
  75: "bg-indigo-50/75",
  90: "bg-indigo-50/90",
  100: "bg-indigo-50",
};

const from = {
  5: "from-indigo-50/5",
  10: "from-indigo-50/10",
  25: "from-indigo-50/25",
  50: "from-indigo-50/50",
  75: "from-indigo-50/75",
  90: "from-indigo-50/90",
  100: "from-indigo-50",
};

export default function getBackgroundIndigo50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
